import { useEffect, useState, useCallback, memo } from "react";
import useEmblaCarousel from "embla-carousel-react";

import diamond from "@/assets/shots/shop-diamonddetailing.jpg.asset.json";
import foreva from "@/assets/shots/shop-forevadifferent.jpg.asset.json";
import goap from "@/assets/shots/shop-goap.jpg.asset.json";
import hybforce from "@/assets/shots/shop-hybforce.jpg.asset.json";
import laluun from "@/assets/shots/shop-laluunbaby.jpg.asset.json";
import shay from "@/assets/shots/shay-body-butter.jpg.asset.json";
import balzy from "@/assets/shots/shop-balzy.jpg.asset.json";

const shots = [
  { url: diamond.url, alt: "Diamond Detailing webshop" },
  { url: foreva.url, alt: "ForevaDifferent webshop" },
  { url: shay.url, alt: "Shay Skincare Body Butter Cucumber Oasis productpagina" },
  { url: hybforce.url, alt: "Hybforce webshop" },
  { url: goap.url, alt: "GOAP webshop" },
  { url: laluun.url, alt: "La Luun Baby webshop" },
  { url: balzy.url, alt: "Balzy webshop" },
];

const WebshopScreenshotsMarquee = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "center",
    dragFree: false,
    containScroll: false,
  });
  const [selected, setSelected] = useState(0);

  const onSelect = useCallback(() => {
    if (emblaApi) setSelected(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <section className="bg-primary w-full pt-20 md:pt-32 pb-12 md:pb-20 overflow-hidden">
      <div className="cursor-grab active:cursor-grabbing" ref={emblaRef}>
        <div className="flex px-4 md:px-8 items-center">
          {shots.map((shot, i) => {
            const isActive = i === selected;
            return (
              <div
                key={i}
                className="flex-[0_0_72%] sm:flex-[0_0_46%] md:flex-[0_0_32%] lg:flex-[0_0_23%] min-w-0 px-2 md:px-3"
              >
                <div
                  className={`overflow-hidden rounded-3xl border border-white/10 bg-card transition-all duration-500 ease-out ${
                    isActive
                      ? "scale-[1.12] shadow-2xl opacity-100 relative z-10"
                      : "scale-95 shadow-md opacity-70 brightness-[0.65]"
                  }`}
                >
                  <img
                    src={shot.url}
                    alt={shot.alt}
                    loading="lazy"
                    decoding="async"
                    draggable={false}
                    className="w-full aspect-[1040/3100] object-cover object-top select-none"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default memo(WebshopScreenshotsMarquee);
